import { useEffect } from 'react';
import I18n from 'I18n';
import { useUnifiedAccount } from 'unified-auth';
import PortalIdParser from 'PortalIdParser';
export const UnifiedAccServiceComponent = ({
  metadata = {},
  onAuthCancelled,
  onAuthSucceeded,
  reconnectStarted
}) => {
  const portalId = PortalIdParser.get();
  const appId = metadata.appId || 0;
  const accountId = metadata.accountId || '0';
  const unifiedAccountId = metadata.unifiedAccountId || 0;
  const isUnifiedAccountMigration = !!metadata.isUnifiedAccountMigration;
  const onComplete = response => {
    onAuthSucceeded === null || onAuthSucceeded === void 0 || onAuthSucceeded(String(response.accountId));
  };
  const onCancel = () => {
    onAuthCancelled === null || onAuthCancelled === void 0 || onAuthCancelled({
      message: I18n.text('reconnect.warnings.reconnectionCancelled')
    });
  };
  const {
    isLoading,
    Modal,
    openModal,
    isOpen
  } = useUnifiedAccount(Object.assign({
    appId,
    portalId,
    accountId: unifiedAccountId || Number(accountId)
  }, isUnifiedAccountMigration && !unifiedAccountId && {
    oAuthorAccountId: accountId ? `${accountId}` : ''
  }), {
    onComplete,
    onCancel
  });
  useEffect(() => {
    if (reconnectStarted && !isOpen && openModal) {
      openModal();
    }
  }, [reconnectStarted, isOpen, openModal]);
  return reconnectStarted && !isLoading && isOpen ? Modal : null;
};